"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var description_1 = require("./utils/description");
var typeToPredicate_1 = require("./typeToPredicate");
/**
 * Asserts that value satisfies given predicate, otherwise throws a given error with provided message
 *
 * @example
 *
 * // if no message provided then description of the predicate will be taken
 * is.assert(is.string)(null) // Error('Assertion failed. Must be a string')
 *
 * // simple types are mapped to predicates so they get the same description
 * is.assert(String)(null) // Error('Assertion failed. Must be a string')
 *
 * is.assert(String)('string') // undefined - everything is fine
 * is.assert(is.not(is.empty), 'Value is required')(''); // Error('Value is required')
 *
 * // custom error class allowed
 * is.assert(String, undefined, CustomErrorClass)(null); // CustomErrorClass('Assertion failed. Must be a string');
 */
function assert(predicate, message, exceptionClass) {
    if (exceptionClass === void 0) { exceptionClass = Error; }
    predicate = typeToPredicate_1.getPredicateForType(predicate) || predicate;
    return function (value) {
        var extraArgs = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            extraArgs[_i - 1] = arguments[_i];
        }
        if (!predicate.apply(void 0, [value].concat(extraArgs))) {
            throw new exceptionClass(message || 'Assertion failed. Must be ' + description_1.getDescription(predicate));
        }
    };
}
exports.assert = assert;
